export class ApiRequestError extends Error {
  readonly code: number
  readonly reason: string
  readonly requestId: string
  readonly status: number

  constructor(message: string, options: { code?: number, reason?: string, requestId?: string, status?: number } = {}) {
    super(message)
    this.name = 'ApiRequestError'
    this.code = Number(options.code ?? 0)
    this.reason = String(options.reason ?? '')
    this.requestId = String(options.requestId ?? '')
    this.status = Number(options.status ?? 0)
  }
}

/** 为每次前端请求生成可反馈给运维的稳定标识。 */
export function createApiRequestId() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID()
  }
  return `web_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`
}

/** 将 Axios、业务码失败和普通异常统一为页面可消费的错误结构。 */
export function normalizeApiRequestError(error: any) {
  if (error instanceof ApiRequestError) {
    return error
  }

  const response = error?.response
  const responseData = response?.data
  const payload = typeof responseData === 'object' && responseData !== null ? responseData : error
  const detail = typeof payload?.data === 'object' && payload.data !== null ? payload.data : {}
  const headers = response?.headers ?? {}
  const requestHeaders = error?.config?.headers ?? {}
  const requestId = detail.request_id
    || headers['x-request-id']
    || headers['X-Request-ID']
    || requestHeaders['X-Request-ID']
    || requestHeaders['x-request-id']
    || ''
  const message = detail.error_message
    || payload?.message
    || payload?.msg
    || error?.message
    || '请求失败'

  return new ApiRequestError(String(message), {
    code: Number(payload?.code ?? 0),
    reason: String(detail.reason ?? payload?.reason ?? ''),
    requestId: String(requestId),
    status: Number(response?.status ?? error?.status ?? payload?.status ?? 0),
  })
}

/** Toast 中同时展示错误原因和 request ID，便于运营反馈后定位日志。 */
export function apiErrorDescription(error: unknown) {
  const normalized = normalizeApiRequestError(error)
  return normalized.requestId
    ? `${normalized.message}（请求 ID：${normalized.requestId}）`
    : normalized.message
}
